import { PlatformHero } from '@/components/platform/PlatformHero';
import { FourPillarsSection } from '@/components/platform/FourPillarsSection';
import { IntegrityTableSection } from '@/components/platform/IntegrityTableSection';
import { SecurityInvariantsSection } from '@/components/platform/SecurityInvariantsSection';
import { TrustComplianceSection } from '@/components/platform/TrustComplianceSection';
import { PlatformCTA } from '@/components/platform/PlatformCTA';

const Platform = () => {
  return (
    <>
      <PlatformHero />
      <FourPillarsSection />
      <IntegrityTableSection />
      <SecurityInvariantsSection />
      <TrustComplianceSection />
      <PlatformCTA />
    </>
  );
};

export default Platform;
